//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectsComp.css';
import { Row, Col } from 'react-flexbox-grid';

import Button from '../common/ButtonComp';
import { isWizardPassed } from '../reducers/wizardReducer';
import ProjectActions from '../actions/project.actions';
import { bindActionCreators } from 'redux';
import MdSettings from 'react-icons/lib/md/settings';
import MdBrightness1 from 'react-icons/lib/md/brightness-1';
//import {IconMenu, MenuItem, MenuDivider } from 'react-toolbox/lib/menu';
import MenuItem from 'react-toolbox/lib/menu/MenuItem';
import IconMenu from 'react-toolbox/lib/menu/IconMenu';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router-dom';
import Switch from 'react-toolbox/lib/switch/Switch';
import Dialog from 'react-toolbox/lib/dialog/Dialog';
import { getTranslate } from 'react-localize-redux';

function ACCOUNT_CHOOSER(url, email) {
  return `https://accounts.google.com/AccountChooser?source=ogb&continue=${encodeURIComponent(
    url
  )}&Email=${encodeURIComponent(email)}`;
}

const WEB_PROPERTY_LINK =
  'https://analytics.google.com/analytics/web/#/report/content-pages/a{accountId}w{internalWebPropertyId}p{profileId}';

class ProfileComp extends Component {
  state = {
    hideDisabled: true
  };

  constructor(props) {
    super(props);
    this.state = {
      hideDisabled: localStorage.getItem('hideDisabled') !== 'false'
    };
  }

  closeRemoveDialog = () => {
    this.props.projectActions.closeRemoveProjectDialog();
  };

  closeDisableDialog = () => {
    this.props.projectActions.closeDisableProjectDialog();
  };

  addDomain() {
    const {
      routerActions,
      projectActions,
      me: {
        user: { projects }
      }
    } = this.props;

    projectActions.createProject({});
  }

  toggleDisabled() {
    const newHideDisabled = !this.state.hideDisabled;
    this.setState({ hideDisabled: newHideDisabled });
    localStorage.setItem('hideDisabled', newHideDisabled.toString());
  }

  onSelectItem({ idx, id }, value) {
    const { me, projectActions } = this.props;

    switch (value) {
      case 'change':
        this.props.routerActions.push(`/wizard/select-plan?idx=${idx}`);
        return;
      case 'settings':
        this.props.routerActions.push(`/wizard/get-client?idx=${idx}`);
        return;
      case 'deactivate':
        const toDisableProject = me.user.projects.find(({ _id }) => _id === id);

        if (toDisableProject.plan && toDisableProject.plan.id !== 'free') {
          projectActions.openDisableProjectDialog({ id });
        } else {
          projectActions.disableProject({
            id
          });
        }
        return;
      case 'activate':
        this.props.projectActions.enableProject({ id });
        return;
      case 'delete':
        this.props.projectActions.deleteProject({ id });
        return;
      case 'remove':
        this.props.projectActions.openRemoveProjectDialog({ id });
        return;
      case 'seo_perf':
        this.props.routerActions.push(`/wizard/seo-perfomance?idx=${idx}`);
        return;
      case 'filters':
        this.props.routerActions.push(`/filters?idx=${idx}`);
        return;
      default:
        return;
    }
  }

  render() {
    const {
      translate,
      me: {
        user: { projects }
      }
    } = this.props;

    const toRemoveProject = projects.find(({ _id }) => {
      return _id === this.props.project.removeProjectId;
    });

    const toDisableProject = projects.find(({ _id }) => {
      return _id === this.props.project.disableProjectId;
    });

    const dialogProjectIndex = projects.indexOf(toDisableProject || toRemoveProject);

    let agencyInfo;

    let addDomainButton = (
      <h1 className="profile-header">
        {translate('profile.your_domains')}
        <Button big inverted black onClick={this.addDomain.bind(this)}>
          {translate('profile.add')}
        </Button>
      </h1>
    );

    let projectsList = projects.map(domainComp.bind(this));
    let noProjectWarn = (
      <div>
        <h3>{translate('profile.noProjectsExists.warn')}</h3>
        <Button big primary onClick={this.addDomain.bind(this)}>
          {translate('profile.add')}
        </Button>
      </div>
    );

    let removeProjectDialog = this.props.project.showRemoveDialog &&
      toRemoveProject && (
        <Dialog
          actions={[
            {
              label: translate('profile.removeDialog.ok'),
              onClick: () =>
                this.props.projectActions.deleteProject({
                  id: toRemoveProject._id
                }),
              raised: true,
              accent: true
            },
            {
              label: translate('profile.removeDialog.cancel'),
              onClick: this.closeRemoveDialog
            }
          ]}
          active={this.props.project.showRemoveDialog}
          onEscKeyDown={this.closeRemoveDialog}
          onOverlayClick={this.closeRemoveDialog}
          title={translate('profile.removeDialog.title', {
            name: toRemoveProject.name || `Project ${dialogProjectIndex}`
          })}
        >
          <h4>
            {translate('profile.removeDialog.text', {
              name: toRemoveProject.name || `Project ${dialogProjectIndex}`
            })}
          </h4>
        </Dialog>
      );

    let disableProjectDialog = this.props.project.showDisableDialog &&
      toDisableProject && (
        <Dialog
          actions={[
            {
              label: translate('profile.disableDialog.ok'),
              onClick: () =>
                this.props.projectActions.disableProject({
                  id: toDisableProject._id
                }),
              raised: true,
              accent: true
            },
            {
              label: translate('profile.disableDialog.cancel'),
              onClick: this.closeDisableDialog
            }
          ]}
          active={this.props.project.showDisableDialog}
          onEscKeyDown={this.closeDisableDialog}
          onOverlayClick={this.closeDisableDialog}
          title={translate('profile.disableDialog.title', {
            name: toDisableProject.name
          })}
        >
          <h4>
            {translate('profile.disableDialog.text', {
              name: toDisableProject.name
            })}
          </h4>
        </Dialog>
      );

    return (
      <div className="profile">
        {addDomainButton}

        {agencyInfo}
        <div className="content">{projects.length ? projectsList : noProjectWarn}</div>

        {removeProjectDialog}
        {disableProjectDialog}
      </div>
    );
  }
}

function domainComp(project) {
  const { translate } = this.props;
  const { plan = { web_id: 'free' } } = project;
  const planClassName = ['profile-domain-plan', `domain-plan-${plan.web_id}`].join(' ');
  const domainClassName = ['profile-domain', `domain-status-${getStatusForProject(project)}`].join(
    ' '
  );

  const analyticsPropertyLink =
    project.profileId &&
    WEB_PROPERTY_LINK.replace('{accountId}', project.accountId)
      .replace('{internalWebPropertyId}', project.internalWebPropertyId)
      .replace('{profileId}', project.profileId);

  const toggleDomain = project.disabled ? (
    <MenuItem value="activate" caption={translate('profile.activate')} />
  ) : (
    <MenuItem value="deactivate" caption={translate('profile.deactivate')} />
  );

  const removeProject = project.disabled && (
    <MenuItem value="remove" caption={translate('profile.remove')} />
  );

  let domainActionButton = (
    <Button
      to={`/wizard/select-web-property?idx=${project.index}`}
      big
      secondary
      wide
      disabled={project.disabled}
    >
      {translate('profile.complete')}
    </Button>
  );

  let changePlan = !project.disabled && (
    <MenuItem value="change" caption={translate('profile.change_plan')} />
  );

  let filters = !project.disabled && (
    <MenuItem value="filters" caption={translate('filters.set_up_link')} />
  );

  let seoPerfomanceButton = (
    <MenuItem
      value="seo_perf"
      caption={translate(
        project.sendSeoPerformanceEmail
          ? 'profile.disableSeoPerfomance'
          : 'profile.enableSeoPerfomance'
      )}
    />
  );

  if (project.profileId)
    domainActionButton = (
      <Button
        href={ACCOUNT_CHOOSER(analyticsPropertyLink, project.accessEmail)}
        target="_blank"
        big
        primary
        wide
        disabled={project.disabled}
      >
        {translate('profile.view')}
      </Button>
    );
  const iconForMenu = <MdSettings className="profile-domain-settings" />;
  return (
    <div className={domainClassName} key={project.index}>
      <Row>
        <Col xs={7}>
          <h3>
            <MdBrightness1 className="profile-domain-status-icon" />
            {project.name || `Project ${project.index}`}
          </h3>
        </Col>
        <Col xs={5}>
          <Row end="xs">
            <Col className={planClassName}>{translate(`plans.${plan.web_id}_plan`)}</Col>
            <Col className="profile-domain-action">{domainActionButton}</Col>
            <Col className="profile-domain-menu">
              <IconMenu
                icon={iconForMenu}
                onSelect={this.onSelectItem.bind(this, { idx: project.index, id: project._id })}
                position="topLeft"
                menuRipple
                className="kwh-dropdown-menu"
              >
                {changePlan}
                <MenuItem value="settings" caption={translate('profile.get_token')} />
                {toggleDomain}
                {removeProject}
                {seoPerfomanceButton}
                {filters}
              </IconMenu>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

function getStatusForProject(project) {
  if (project.disabled) return 'disabled';
  if (
    !project.wizard ||
    !~project.wizard.indexOf('get-client') ||
    !~project.wizard.indexOf('select-plan') ||
    !~project.wizard.indexOf('select-web-property')
  )
    return 'incomplete';
  return 'done';
}

function isWizardDone(project) {
  return isWizardPassed({ passed: project.wizard });
}
function isUploadAccountPending(project) {
  return project.schedule && project.schedule.scheduleCreateAccount;
}

function mapStateToProps(state) {
  return {
    translate: getTranslate(state.locale),
    wizard: state.wizard,
    me: state.me,
    project: state.project
  };
}

function mapDispatchToProps(dispatch) {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    projectActions: bindActionCreators(ProjectActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileComp);



// WEBPACK FOOTER //
// ./src/projects/ProjectsComp.js